import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
import { Subscription } from 'rxjs';

import { AuthService } from './shared/services/auth.service';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'fitpass';

  constructor(private primeng: PrimeNG, private router: Router, private authService: AuthService) {
    Sentry.setTags({
      application: 'Frontend',
    });
  }

  ngOnInit(): void {
    this.primeng.ripple.set(true);
  }

}
